import React from 'react'
import { useTranslation } from 'react-i18next'
import {
	NotFoundDescription,
	NotFoundTitle,
	NotFoundPageWrapper,
	NotFoundMessageContainer,
} from './NotFound.style'

const NotFound = () => {
	const { t } = useTranslation()

	return (
		<NotFoundPageWrapper>
			<NotFoundMessageContainer>
				<NotFoundTitle>{t('404.title')}</NotFoundTitle>
				<NotFoundDescription>{t('404.description')}</NotFoundDescription>
			</NotFoundMessageContainer>
		</NotFoundPageWrapper>
	)
}

export default NotFound
